import { useState, useEffect } from "react";
import "./RenameFormModal.css";
import Modal from "../shared/Modal";
import { CreateQuestionForFormPayload, Question, QuestionType, UpdateFormNamePayload, UpdateFormQuestionOrderPayload } from "effno-core";
import { toastFail, toastSuccess } from "../../config";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { selectEditingForm, setEditingForm, setEditingQuestionId, setUIStates } from "../../redux/features/appData";
import { apiCreateQuestionForForm } from "../../services/QuestionService";
import { useDispatch } from "react-redux";
import { apiUpdateFormName, apiUpdateFormQuestionOrder } from "../../services/FormService";
import { addNewQuestionToOrder } from "../shared/uiHelpers";

type RenameFormModalProps = {
    isOpen: boolean;
    onClose: () => void;
}

export const RenameFormModal = ({isOpen, onClose}: RenameFormModalProps) => {

    const dispatch = useDispatch();

    const editingForm = useSelector(selectEditingForm);

    const [newName, setNewName] = useState(editingForm?.name || "");

    const handleSave = async () => {
        if (!editingForm) {
            return;
        }

        const payload: UpdateFormNamePayload = {
            formId: editingForm.id,
            name: newName
        }

        const newForm = await apiUpdateFormName(payload);

        if (!newForm) {
            toast("Failed to update name", toastFail);
            return;
        }

        dispatch(setEditingForm(newForm));
        toast("Name updated", toastSuccess);
        onClose();
    }

    return (
        <Modal
            isOpen={isOpen}
            style={null}
            onClose={onClose}
            canClose={true}
            allowClickout={true}
        >
            <div className="rename-form-container">
                <div className="modal-title">
                    Rename
                </div>

                <div 
                    className="rename-form-name"
                    onChange={(e: any)=>setNewName(e.target.value)}
                >
                    <input
                        type="text"
                        value={newName}
                        autoFocus={true}
                        onKeyDown={(e: any)=>{
                            if (e.key === "Enter") {
                                handleSave();
                            }
                        }}
                    />
                </div>
                
                <div className="modal-buttons">
                    <button
                        className="button-cancel"
                        onClick={()=>{
                            onClose();
                        }}
                    >
                        Cancel
                    </button>
                    <button
                        className="rename-form-action button-save"
                        onClick={handleSave}
                        disabled={newName.length === 0}
                    >
                        Save
                    </button>
                </div>

            </div>

      </Modal>
    )
}